import React from "react";
import { useContext } from "../../context";
import { NoShow } from "./NoShow";
import { AVAILABLE_BUTTONS } from "../../../../../../../../api/appointments/useAppointmentQuery";
import { Cancel } from "./Cancel";
import { CheckIn } from "./CheckIn";
import { CheckOut } from "./CheckOut";
import { CancelForAdditionalProvider } from "./CancelForAdditionalProvider";
import { PaymentLink } from "./PaymentLink";
import { ReleaseAppointment } from "./ReleaseAppointment";
import { APPOINTMENT_STATUSES } from "../../../../../../../../store/event/consts";
import styles from "./styles.module.scss";

export function Actions() {
  const { appointment } = useContext();

  const actions = [
    {
      id: "paymentLink",
      component: PaymentLink,
      /* gated on status so a normal appointment never triggers the Stripe lookup */
      isVisible: appointment.status === APPOINTMENT_STATUSES.pendingPayment,
    },
    {
      id: "releaseAppointment",
      component: ReleaseAppointment,
      /*
       * Only a cancellation-policy hold. A deposit has an invoice, and that
       * slot is released by cancelling the pending payment, not from here.
       */
      isVisible:
        appointment.status === APPOINTMENT_STATUSES.pendingPayment &&
        !appointment.invoiceId,
    },
    {
      id: "noShow",
      component: NoShow,
      isVisible:
        appointment.availableButtons.includes(AVAILABLE_BUTTONS.noShow) &&
        !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "cancel",
      component: Cancel,
      isVisible:
        appointment.availableButtons.includes(
          AVAILABLE_BUTTONS.cancelAppointment,
        ) || appointment.isAdditionalProviderAppointment,
    },
    {
      id: "cancelForAdditionalProvider",
      component: CancelForAdditionalProvider,
      isVisible: appointment.isAdditionalProviderAppointment,
    },
    {
      id: "checkIn",
      component: CheckIn,
      isVisible:
        appointment.availableButtons.includes(
          AVAILABLE_BUTTONS.patientCheckIn,
        ) && !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "checkOut",
      component: CheckOut,
      isVisible:
        appointment.availableButtons.includes(
          AVAILABLE_BUTTONS.patientCheckOut,
        ) && !appointment.isAdditionalProviderAppointment,
    },
  ].filter((x) => x.isVisible);

  return (
    <div className={styles.root}>
      {actions.map((action) => (
        <action.component key={action.id} />
      ))}
    </div>
  );
}
